import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import WatchNowButton from '@/components/buttons/WatchNowButton.vue';

import type { SponsoredAdFragment } from '@/features/sponsored-recommendations/graphql/fragments/SponsoredAd.fragment';
import type { SingleTitleSR } from '@/features/sponsored-recommendations/types';
import { faTicket, faBookmark } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionItems',
  props: {
    sponsoredCampaign: null,
    isInWatchlist: { type: Boolean, default: false },
    additionalContexts: { default: () => [] },
    isCinemaSR: { type: Boolean, default: false },
    lazy: { type: Boolean, default: true },
    promotionalProviderLogo: null,
    large: { type: Boolean, default: false },
    hideBookmarkButton: { type: Boolean },
    hideDetailPageButton: { type: Boolean, default: false }
  },
  emits: ["onWatchNowClick", "onClickMore", "toggleWatchlist"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'onWatchNowClick'): void;
	(e: 'onClickMore'): void;
	(e: 'toggleWatchlist', data: SingleTitleSR): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { sponsoredCampaign: NonNullable<SponsoredAdFragment['campaign']>, isInWatchlist: boolean, additionalContexts: SnowplowContext[], isCinemaSR: boolean, lazy: boolean, promotionalProviderLogo?: string | null, large: boolean, hideBookmarkButton?: boolean, hideDetailPageButton: boolean };





const campaignNode = computed<SingleTitleSR>(() => props.sponsoredCampaign?.node as SingleTitleSR);
const watchNowOffer = computed(() => props.sponsoredCampaign.watchNowOffer);
const watchNowLabel = computed(() => props.sponsoredCampaign.watchNowLabel);
const hideDetailPageButton = computed(() => props.sponsoredCampaign.hideDetailPageButton || props.hideDetailPageButton);

const titleObject = computed(() => {
	const campaignNodeContent =
		campaignNode.value.__typename === 'Season' ? campaignNode.value.show : campaignNode.value;

	return {
		id: campaignNodeContent.objectId,
		type: campaignNodeContent.objectType,
	};
});

return { __sfc: true,props, emits, campaignNode, watchNowOffer, watchNowLabel, hideDetailPageButton, titleObject, ProviderIcon, WatchNowButton, faTicket, faBookmark }
}

})